
export const SUPPORTED_LANGUAGES: string[] = [
  'en', 'hi', 'iw', 'ar', 'id', 'pt', 'es', 'fr', 'de', 'bn', 'gu', 'kn',
  'ml', 'mr', 'or', 'pa', 'ta', 'te', 'ru', 'vi', 'pl', 'th', 'tr', 'ur',
  'en_AU',
];

export const RTL_LANGUAGES: string[] = ['ar', 'iw', 'ur'];
